export class ErrorCode {
  static generateWithPrefix(prefix: string): string {
    const errorCode = Math.floor(Math.random() * 10000)
      .toString()
      .padStart(4, '0');
    return `${prefix}-${errorCode}`;
  }
}
